import styled, { css } from 'styled-components';
import PagebuilderListItem from 'gatsby-theme-pagebuilder/src/components/blocks/list/list-item';

const PDVListItem = styled(PagebuilderListItem).attrs((props) => ({
  chevronRight: true,
  withLink: props.$variant === 'standout',
  overrideContentTheme: props.$variant === 'standout' ? 'light' : null,
}))`
  ${({ $variant }) => $variant === 'standout' && css`
    background-color: pink;
    border-radius: 0.4rem;
    &:nth-child(3n+1) {
      background-color: #D43E7C;
    }
    &:nth-child(3n+2) {
      background-color: #2BAAE2;
    }
    &:nth-child(3n+3) {
      background-color: #9AC22B;
    }

    && > * {
      display: grid;
      padding: 2rem;
      color: white;
      .list-item-icon {
        grid-row: 1 / span 2;
        grid-column: 1;
        align-self: start;
      }
      > *:not(.list-item-icon) {
        grid-column: 2;
      }
      a {
        &:hover {
          color: inherit;
        }
      }
    }
  `}

  ${({ $variant }) => $variant === 'buttons' && css`
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
    border-radius: 0.4rem;
    > * {
      padding: 1.5rem 2rem;
      font-weight: 700;
    }
  `}
`;

export default PDVListItem;
